import React from 'react'
import Link from '../components/Link'
import { Button, Col, Container, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap'

import Footer from '../components/Footer'
import Logo from '../components/Logo'

import deviceImage from '../assets/images/device.png'
import newLanguageImage from '../assets/images/using.png'
import peopleImage from '../assets/images/people.png'

import styles from './index.module.scss'

export default () => (
  <div>
    <Container className={ styles.hero } fluid>
      <Row>
        <Logo />
        <h1>Deploy in 50ms.<br/> <Link to="https://ellenchisa.us16.list-manage.com/subscribe?u=80505145cb9174d810cff1e7c&id=4ae7d71f93&EMAIL=">Join the mailing list.</Link></h1>
      </Row>
    </Container>
    <Container className={ styles.body } fluid>
      <Row>
        <Col xs={ 11 } md={ 8 }>
          <p className="lead">Dark is a holistic programming language, structured editor, and infrastructure, for building backend web services. It's for frontend, backend, and mobile engineers.</p>
         
          <hr/>
          <p>Our goal is to make coding 100x easier, which we believe will allow a billion people to build software. This is a huge challenge, that requires a significant rethink of how we write software.</p>
          <p>The defining principle behind Dark is that we want to remove all accidental complexity from coding. Building applications today is incredibly complex, and a great deal of that complexity is accidental.</p>
          
          <p>What are the major sources of complexity today?</p>
          <ul>
            <li><strong>Infrastructure</strong> is time consuming and difficult, especially as services start to scale.</li>
            <li><strong>Deployment</strong> is risky because you’ve only tested on your own machine, and now you need to run the same code on many different machines, to serve (millions of) users.</li>
            <li><strong>APIs</strong> and 3rd-party services initially accelerate development speed, but over time you dedicate an increasing amount of time on making it resilient.</li>
          </ul>
          <p>Dark allows developers to:</p>
          <ul>
            <li>Generate and run scalable infrastructure.</li>
            <li>Use APIs as easily as if they were functions.</li>
            <li>Remove the deployment step entirely.</li>
          </ul>

          <p>Learn more about the <a href="https://medium.com/darklang/the-design-of-dark-59f5d38e52d2">philosophy and design behind Dark</a>.</p>
          <hr/>

          <p className="lead"> Dark is currently in private alpha.</p>

          <p>We've had developers ship products (with paying customers!) ship on Dark.</p>

          <p>Projects that are currently a good fit:</p>
          <ul>
          <li> are SPAs, mobile products, new microservices in existing architectures, and internal tools.</li>
          <li> need API endpoints, cron jobs, databases, queues, etc.</li>
          <li>don't need a backend outside of "regular business logic": machine learning models, blockchain, real-time systems, or streaming video.</li>
          </ul>

          <p> If you have something that fits these criteria and want to build it right now, please leave a note about it in the "anything else?" box when you sign up for the beta. We also offer a <a href="https://medium.com/darklang/dark-residency-7dbc878a5f0a">developer residency</a> on a rolling basis.</p>
          <hr/>
          </Col>
      </Row>
    </Container>
    <Footer />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/index.js